import apiFn from 'common/services/api-service';

const EVENTMOBI_MASTERLIST_UUID = 'e95ccf5140d6424d8ff585554e59f065';

const api = () =>
  apiFn(`/api/cms/v1/views/masterlists/${EVENTMOBI_MASTERLIST_UUID}/masterlist-query`, {
    Accept: 'application/vnd.eventmobi+json; version=p.4',
  });

export const searchEvents = async (params = {}) => {
  const {
    search = '',
    searchBy = 'shortcode',
    startDateRange = null,
    limit,
    page = '0',
    sort = '',
    ...otherParams
  } = params;

  const query = { ...otherParams };

  query.limit = parseInt(limit, 10);
  query.offset = parseInt(page, 10) * parseInt(limit, 10);

  // Add search parameter based on searchBy field
  if (search && search.trim()) {
    switch (searchBy) {
      case 'shortcode':
        query.shortcode = search.trim();
        break;
      case 'name':
        query.name = search.trim();
        break;
      case 'id':
        query.eventId = search.trim();
        break;
      case 'organizer':
        query.email = search.trim();
        break;
      default:
        query.shortcode = search.trim();
    }
  }

  if (startDateRange && startDateRange.length === 2) {
    const [startDate, endDate] = startDateRange;
    query.startDateMin = startDate;
    query.startDateMax = endDate;
  }

  if (sort) {
    query.sort = sort;
  }

  return api()
    .get('', { params: query })
    .then(response => response.data);
};
